// src/mocks/handlers/customer/customerUsersHandler.ts
import { rest } from 'msw';
import customerUsers from '@/mocks/data/customerUsers.json';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { ICustomerUsersResponse } from '@/domains/customer/customer.types';
import { API_DEFAULT_PAGE_SIZE } from '@/services/api/api.constants';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const customerUsersHandler = rest.get<ICustomerUsersResponse>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.CUSTOMER_USERS}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    const { customer_uuid } = req.params;
    /* eslint-disable-next-line no-console */
    console.log('customer_uuid', customer_uuid);
    const page = Number(req.url.searchParams.get('page')) || 1;
    const page_size =
      Number(req.url.searchParams.get('page_size')) || API_DEFAULT_PAGE_SIZE;

    const total = customerUsers.users.length;
    const pages = Math.ceil(total / page_size);
    const start = (page - 1) * page_size;
    const results = customerUsers.users.slice(start, start + page_size);

    return res(
      ctx.status(200),
      ctx.json({
        total,
        page,
        pages,
        results,
      }),
    );
  },
);
